var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog-timer"},[_c('h1',[_vm._v(_vm._s(_vm.timer))])])
}
var staticRenderFns = []

export { render, staticRenderFns }